import React, { useState } from 'react';
import '../App.css';
import CryptoChart from './CryptoChart';
import CryptoTable from './CryptoTable';
import CryptoCard from './CryptoCard';


const Dashboard = () => {
    const [selectedCrypto, setSelectedCrypto] = useState('bitcoin');

    const handleCryptoChange = (event) => {
        const selectedValue = event.target.value; 
        console.log('Crypto selected:', selectedValue); 
      setSelectedCrypto(selectedValue);
      };
      const [selectedInterval, setSelectedInterval] = useState('d1');
      const handleIntervalChange = (event) => {
        const selectedValuei = event.target.value; 
        console.log('Interval selected:', selectedValuei); 
      setSelectedInterval(selectedValuei);
      };

  return (
    <section>
      <h1 className='font-bold text-3xl my-8 mx-6'>Crypto Dashboard</h1>
          <div className="m-2 flex px-4 gap-4">
            <select
              id="crypto-select"
              onChange={handleCryptoChange}
              value={selectedCrypto} className='dark:border dark:border-solid dark:border-zinc-800 bg-color1 focus:outline-none'
            >
              <option value="bitcoin">Bitcoin</option>
              <option value="ethereum">Ethereum</option>
              <option value="cardano">Cardano</option>
              <option value="dogecoin">Dogecoin</option>
            </select>

            <select
              id="interval-select"
              onChange={handleIntervalChange}
              value={selectedInterval} className='dark:border dark:border-solid dark:border-zinc-800 bg-color1 focus:outline-none'
            >
                <option value="m1">1 day</option>
                <option value="m15">1 week</option>
                <option value="h1">1 month</option>
                <option value="h6">6 months</option>
                <option value="d1">1 year</option>
            </select>
          </div>
          <div className='flexCont'>
            <div className='flex flex-col gap-4 p-4'>
              <div className='flex gap-4'>
                <CryptoCard selectedCrypto={selectedCrypto}/>
              </div>
              <div className="m-2 graph rounded-xl w-full bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700">
                <CryptoChart selectedCrypto={selectedCrypto} selectedInterval={selectedInterval}/>
              </div>
           </div>
           <div className='p-4 w-full'>
              <div className="m-2 p-8 rounded-xl w-full bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700">
                <CryptoTable />
              </div>
            </div>
          </div>
    </section>
  )
}
export default Dashboard
